module.exports = __webpack_public_path__ + "img/76.a4fa12da.jpg";